import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IGeoCoordinate } from '../types';
import { IServerResponse } from '../types/server-response';
import { TipoUbigeoEnum } from '../utils/enums';

@Injectable({
  providedIn: 'root'
})
export class ApiInvestigadorService {

  private urlAuth = `${environment.baseUrlAPIDWH}/auth`;
  private urlServicioTuni = `${environment.baseUrlAPIDWH}/serviciotuni`;

  constructor(private http: HttpClient) { }

  postSolicitarToken = (data: {
    recaptcha: string,
    tipoInvestigador: string,
    nombreOrganizacion: string,
    cargo: string,
    tipoDocumento: string,
    numeroDocumento: string,
    nombreInvestigador: string,
    apellidoInvestigador: string,
    correo:string,
    telefono: string,
    objetivo: string,
  }) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlAuth}/registrarinvestigador`, data);
  }
  postSolicitarTokenExistente = (data: {
    recaptcha: string,
    correo:string,
    tipoInvestigador: string,
    tipoDocumento: string,
    numeroDocumento: string,
  }) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlAuth}/solicitartokenexistente`, data);
  }
  postRegistrarEncuesta = (data: {
    recaptcha: string,
    usoFacil: number,
    contenidoInformacion: number,
    informacion: string,
    objetivo: string,
    version: number
  }) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlServicioTuni}/registrarencuesta`, data);
  }

  postActualizarCuota = (data: {
    tipoInvestigador: string,
    tipoDocumento: string,
    numeroDocumento: string,
    correo:string,
    nuevaCuota: number,
    month: number,
    year: number,
    sinLimite: Boolean
  }) => {
    return this.http.post<IServerResponse<any[]>>(`${this.urlAuth}/ActualizarCuota`, data);
  }
}
